import type { VisibilityState } from '@tanstack/react-table'
import { useState } from 'react'

export function useColumnVisibility(
  storageKey: string,
  defaultVisibility?: VisibilityState,
): {
  columnVisibility: VisibilityState
  onColumnVisibilityChange: (nextVisibility: VisibilityState) => void
} {
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(() => {
    try {
      const stored = localStorage.getItem(storageKey)
      if (stored) {
        const parsed: unknown = JSON.parse(stored)
        if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
          return parsed as VisibilityState
        }
      }
    } catch {
      // corrupt JSON — fall through to default
    }
    return defaultVisibility ?? {}
  })

  function onColumnVisibilityChange(nextVisibility: VisibilityState) {
    setColumnVisibility(nextVisibility)
    localStorage.setItem(storageKey, JSON.stringify(nextVisibility))
  }

  return { columnVisibility, onColumnVisibilityChange }
}
